import type { GetLinkedItemAuditByIdResponseRow } from '@risksmart-app/drizzle/src/dto';
import type { GetLinkedItemAuditQuery } from '@risksmart-app/web-graphql-client/generated/graphql';
import { GetLinkedItemAuditDocument } from '@risksmart-app/web-graphql-client/generated/graphql';
import { createQueryHook } from 'src/utils';

type UseGetLinkedItemAuditByIdArgs = { id: string };

export const useGetLinkedItemAuditById = createQueryHook<
  UseGetLinkedItemAuditByIdArgs,
  GetLinkedItemAuditByIdResponseRow[],
  GetLinkedItemAuditQuery
>({
  trpcQueryOptions: (trpc, { id }) =>
    trpc.frontend.auditLog.getLinkedItemAuditById.queryOptions({ id }),
  mapTrpcDataToGraphQL: (data) => ({ risksmart_linked_item_audit: data }),
  graphqlDocument: GetLinkedItemAuditDocument,
  graphqlVariables: ({ id }) => ({ Id: id }),
});
